import { render, staticRenderFns } from "./MultiProductNotesWizard.vue?vue&type=template&id=5bb56d6e&scoped=true"
import script from "./MultiProductNotesWizard.vue?vue&type=script&lang=js"
export * from "./MultiProductNotesWizard.vue?vue&type=script&lang=js"
import style0 from "./MultiProductNotesWizard.vue?vue&type=style&index=0&id=5bb56d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb56d6e",
  null
  
)

export default component.exports